import React, { useState, useRef, useImperativeHandle } from "react";
import { Tooltip, theme } from "antd";
import {
  EditOutlined,
  PlusCircleFilled,
} from "@ant-design/icons";
import TSTable from "../../../common/TSTable";
import ColorButton from "../../../common/ColorButton";
import { DELETE } from "../../../frameworks/HttpClient";
import { URL_SETTING } from "../../../constants/urls";
import SellLatexModal from "./SellLatexModal";
import ErrorMessages from "../../../common/ErrorMessages";
import { dateToHumanString } from "../../../frameworks/Util";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTruck } from "@fortawesome/free-solid-svg-icons";
import SellSupplierVehicleModal from "./SellSupplierVehicleModal";
import CustomDeleteConfirmButton from "../../../common/CustomDeleteConfirmButton";

const SellLatexList = React.forwardRef((props, ref) => {
  const { isDone } = props;
  const [openAddSellLatexModal, setOpenAddSellLatexModal] = useState(false);
  const [target, setTarget] = useState(null);
  const [vehicleTarget, setVehicleTarget] = useState(null);
  const tableRef = useRef(null);
  const [errorMessages , setErrorMessages] = useState(null);

  const {
    token: { colorWarning, colorSuccess },
  } = theme.useToken();

  useImperativeHandle(ref, () => ({
    fetchTable: refreshData,
  }));

  const refreshData = async () => {
    if (tableRef.current) {
      setErrorMessages(null);
      try {
        await tableRef.current.fetchWithoutResetPage();
      } catch (error) {
        setErrorMessages (error.errorMessages);
      }
    }
  };

  const handleEdit = (record) => {
    if (!record || !record.id) {
      return;
    }
    setTarget(record);
    setOpenAddSellLatexModal(true);
  };

  const handleDelete = async (id) => {
    if (!id) {
      return;
    }
    setErrorMessages(null);
    try {
      await DELETE(`${URL_SETTING.SELLER_RAW_LATEX}${id}/`);
      refreshData();
    } catch (error) {
      setErrorMessages (error.errorMessages);
    }
  };

  const columns = [
    {
      title: "Action",
      dataIndex: "",
      width: 150,
      key: "action",
      align: "center",
      render: (_, record) =>
        isDone ? null : (
          <div onClick={(e) => e.stopPropagation()}>
            <CustomDeleteConfirmButton
              title={`ยืนยันลบหรือไม่`}
              content={"ยืนยันการลบรายการนี้หรือไม่ ?"}
              onOk={ async() => {
                await handleDelete(record.id)
                refreshData();
              }}
              onConfirm={() => refreshData()}
            />
            <Tooltip triger='hover' title="แก้ไขข้อมูล">
              <ColorButton
                type="primary"
                override={colorWarning}
                style={{ margin: 5 }}
                icon={<EditOutlined />}
                onClick={() => handleEdit(record)}
              />
            </Tooltip>
            <Tooltip triger='hover' title="รถขนน้ำยางสด">
              <ColorButton
                type="primary"
                override={colorSuccess}
                style={{ margin: 5 }}
                icon={<FontAwesomeIcon icon={faTruck} />}
                onClick={() => setVehicleTarget(record)}
              />
            </Tooltip>
          </div>
        ),
    },
    {
      title: "รหัส",
      dataIndex: "code",
      key: "code",
      searcher: true,
      align: "center",
    },
    {
      title: "ชื่อผู้ขาย",
      dataIndex: "name",
      key: "name",
      searcher: true,
      align: "center",
    },
    {
      title: "ที่อยู่",
      dataIndex: "address",
      key: "address",
      align: "center",
      width: 250,
    },
    {
      title: "โค้วต้า",
      dataIndex: "quota",
      key: "quota",
      align: "center",
    },
    {
      title: "ค่าบรรทุก",
      dataIndex: "wage",
      key: "wage",
      align: "center",
    },
    {
      title: "หมายเหตุ",
      dataIndex: "note",
      key: "note",
      align: "center",
    },
    {
      title: "วันที่สร้าง",
      dataIndex: "created",
      key: "created",
      align: "center",
      render : (value) => dateToHumanString(value)
    },
  ];

  return (
    <div>
      <ErrorMessages message={errorMessages}/>
      <ColorButton
        type="primary"
        override={colorSuccess}
        icon={<PlusCircleFilled />}
        style={{ marginBottom: 10, float: "right" }}
        onClick={() => setOpenAddSellLatexModal(true)}
      >
        เพิ่มผู้ขายน้ำยางสด
      </ColorButton>
      <TSTable
        columns={columns}
        size="small"
        url={`${URL_SETTING.SELLER_RAW_LATEX}`}
        ref={tableRef}
      />
      <SellLatexModal
        open={openAddSellLatexModal}
        onClose={() => {
          setOpenAddSellLatexModal(false);
          setTarget(null);
        }}
        onUpdate={() => {
          refreshData();
          setOpenAddSellLatexModal(false);
          setTarget(null);
        }}
        target={target}
      />

      <SellSupplierVehicleModal
        open={vehicleTarget ? true : false}
        onClose={() => {
          setVehicleTarget(null)
        }}
        onUpdate={() => {
          refreshData();
          setVehicleTarget(null)
        }}
        target={vehicleTarget}
      />
    </div>
  );
});

export default SellLatexList;
